import { useRuntimeConfig } from '#imports'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useExperienceLayerIsEnabledOnHome() {
  const { market } = useMarketplace()
  const { FF_CMS_HOME_ENABLE_EXPERIENCE_LAYER_COUNTRIES = '' } =
    useRuntimeConfig().public
  return FF_CMS_HOME_ENABLE_EXPERIENCE_LAYER_COUNTRIES?.includes(
    market.countryCode,
  )
}
